export default "__VITE_ASSET__83bd6d91__"